// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CVJPV","col":"styles_col__jm4lb"};